// appModule/index.js
export { useApp } from './hooks/useApp';